import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  getTaskListRequest: null,
  getTaskListSuccess: ['response'],
  getTaskListFailure: null,

  getAssignerTasksRequest: ['branchId', 'startDate', 'endDate', 'timezoneOffset'],
  getAssignerTasksSuccess: ['response'],
  getAssignerTasksFailure: null,

  createNewTaskRequest: ['payload'],
  createNewTaskSuccess: ['response'],
  createNewTaskFailure: null,

  closeTaskRequest: ['taskId', 'payload'],
  closeTaskSuccess: ['taskId'],
  closeTaskFailure: ['taskId'],

  readTaskRequest: ['taskId'],
  readTaskSuccess: ['taskId'],

  approveCompletedRequest: ['taskId'],
  approveCompletedSuccess: ['response'],
  approveCompletedFailure: ['taskId'],

  rejectCompletedRequest: ['taskId', 'payload'],
  rejectCompletedSuccess: ['response'],
  rejectCompletedFailure: ['taskId'],

  approveNewDeadlineRequest: ['taskId'],
  approveNewDeadlineSuccess: ['response'],
  approveNewDeadlineFailure: ['taskId'],

  declineNewDeadlineRequest: ['taskId', 'payload'],
  declineNewDeadlineSuccess: ['response'],
  declineNewDeadlineFailure: ['taskId'],

  getReceiverTasksRequest: ['branchId', 'startDate', 'endDate', 'timezoneOffset'],
  getReceiverTasksSuccess: ['response'],
  getReceiverTasksFailure: null,

  proposeNewDeadlineRequest: ['taskId', 'payload'],
  proposeNewDeadlineSuccess: ['response'],
  proposeNewDeadlineFailure: ['taskId'],

  cancelNewDeadlineRequest: ['taskId'],
  cancelNewDeadlineSuccess: ['response'],
  cancelNewDeadlineFailure: ['taskId'],

  markAsCompletedRequest: ['taskId'],
  markAsCompletedSuccess: ['response'],
  markAsCompletedFailure: ['taskId'],

  removeUncompletedTaskFromQueueRequest: ['category', 'taskId'],

  acknowledgeUncompletedRequest: ['category', 'taskId'],
  acknowledgeUncompletedSuccess: ['category', 'taskId'],
  acknowledgeUncompletedFailure: ['taskId'],

  getTaskListWithOrderRequest: ['category', 'column'],

  getTaskListSearchRequest: ['category', 'searchKeyword'],

  getTaskListWithFilterRequest: ['category', 'column', 'value'],

  // Clear all caches
  clearTasksRequest: null,
});

export const TaskManagementTypes = Types;
export default Creators;
